var map = {
	"./background--1.jpg": 367,
	"./background--2.jpg": 368,
	"./background--3.jpg": 369,
	"./background--4.jpg": 370,
	"./background--5.jpg": 371,
	"./background--6.jpg": 372,
	"./icon-heart-fill.svg": 373,
	"./icon-heart-outline.svg": 374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;